export default __webpack_public_path__ + "static/media/kh.07d04a96.svg";